import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams, Link } from "react-router-dom";
import { ViewUserAppointment, AssignAgentToAppointment } from "../../Redux/Actions/homeVisitActions";
import { AgentList } from "../../Redux/Actions/agentActions";
import { SendAgentNotification } from "../../Redux/Actions/agentActions";
import { ToFirstCapital } from "../../Utils/helpers";
import { ReactComponent as BackIcon } from "../../Assets/Categories/BackIcon.svg";
import SearchBar from "../Main/searchBar";
import { Skeleton, Modal, Select, message } from "antd";
import "./viewHomeVisit.css";

const { Option } = Select;

const ViewHomeVisit = () => {
  const { id } = useParams();
  const dispatch = useDispatch();

  const [isReviewModalOpen, setIsReviewModalOpen] = useState(false);
  const [agentPagination, setAgentPagination] = useState({
    current: 1,
    pageSize: 500,
  });

  const appointment = useSelector((state) => state.homeVisit || {});
  const agentState = useSelector((state) => state.agents || {});

  const loading = appointment?.loading || appointment?.assigningAgent;
  const data = appointment?.appointment || {};
  const agentsData = agentState?.agents || {};
  const assigningAgent = appointment?.assigningAgent || false;
  // const assignmentError = appointment?.assignmentError;

  console.log("dattatatta",data)

  const { admin } = useSelector((state) => state.admin || {});
  const accessCode = admin?.data?.access_code || [];
  const canAdd = Array.isArray(accessCode) && accessCode.includes('add');
  const canEdit = Array.isArray(accessCode) && accessCode.includes('edit');


  const latitude = data?.location?.coordinates?.[1];
  const longitude = data?.location?.coordinates?.[0];

  const fetchAgentsList = useCallback(async () => {
    const agentParams = {
      page: agentPagination.current,
      limit: agentPagination.pageSize,
      is_deleted: false,
      role: ["agent"],
    };
    dispatch(AgentList(agentParams, false));
  }, [dispatch, agentPagination]);

  useEffect(() => {
    if (id) {
      dispatch(ViewUserAppointment(id));
    }
  }, [dispatch, id]);

  useEffect(() => {
    fetchAgentsList();
  }, [fetchAgentsList]);


  const handleAgentSelect = async (agentId) => {
    if (!agentId) {
      message.error("Please select an agent");
      return;
    }

    const selectedAgent = agentsData?.data?.find((agent) => agent._id === agentId);
    if (!selectedAgent) {
      message.error("Agent not found");
      return;
    }

    Modal.confirm({
      title: "Confirm Agent Assignment",
      icon: <span style={{ fontSize: "1.5rem", marginTop: "5px" }}>👤</span>,
      wrapClassName: "confirm-assign-modal",
      content: (
        <div style={{ marginTop: "1rem" }}>
          <p style={{ marginBottom: "1rem", fontSize: "1rem", color: "#1f2937" }}>
            Are you sure you want to assign this appointment to:
          </p>
          <div
            style={{
              background: "#f0f9ff",
              border: "2px solid #bae6fd",
              borderRadius: "12px",
              padding: "1rem",
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: "0.75rem" }}>
              <span style={{ fontSize: "1.5rem" }}>👤</span>
              <div>
                <p style={{ margin: 0, fontWeight: 700, color: "#0d152b", fontSize: "1.125rem" }}>
                  {selectedAgent.name}
                </p>
                <p style={{ margin: "0.25rem 0 0 0", color: "#6b7280", fontSize: "0.875rem" }}>
                  {selectedAgent.staff_id}
                </p>
              </div>
            </div>
          </div>
          <p style={{ color: "#6b7280", fontSize: "0.875rem", marginTop: "1rem", marginBottom: 0 }}>
            This action cannot be undone. The agent will be **notified via push notification**.
          </p>
        </div>
      ),
      okText: "Assign",
      cancelText: "Cancel",
      okButtonProps: {
        style: {
          background: "linear-gradient(135deg, #0D152B 0%, #1a1f3a 100%)",
          borderColor: "#0D152B",
          fontWeight: 700,
        },
      },
      cancelButtonProps: {
        style: {
          fontWeight: 700,
        },
      },
      centered: true,
      onOk: async () => {
        try {
          const notificationPayload = {
            agent_id: agentId,
            title: "New Home Visit Assigned 🏠",
            message: `New home visit appointment assigned to you. User: ${data?.user?.name || data?.user?.user_id || 'N/A'}. Check details now!`,
            type_name: "HOME_VISIT_ASSIGNMENT",
            type_id: id,
            type_data: {
              appointment_id: id,
              user_id: data?.user?._id,
              user_name: data?.user?.name,
              appointment_date: data?.appointment_date
            }
          };

          dispatch(SendAgentNotification(notificationPayload));

          await dispatch(
            AssignAgentToAppointment({
              user_appointment_id: id,
              user: data?.user?._id,
              agent: agentId,
            })
          );

          message.success("Agent assigned successfully!");

          setTimeout(() => {
            dispatch(ViewUserAppointment(id));
          }, 500);
        } catch (error) {
          console.error("Assign agent error:", error);
          message.error("Failed to assign agent. Please try again.");
          throw error;
        }
      },
      onCancel() { },
    });
  };


  // const handleAgentPaginationChange = (pagination) => {
  //   setAgentPagination(pagination);
  // };

  return (
    <div className="view-agent-container-new">
      {/* Header */}
      <div className="searchbar-wrapper">
        <div className="searchbar-container">
          <SearchBar />
        </div>
      </div>

      <div className="view-agent-header back-icon margin-0 gap-10 align-center flex-container">
        <Link to="/home_visit">
          <BackIcon style={{ cursor: "pointer" }} />
        </Link>
        <div className="view-agent-title-section referral-view">
          <h3 className="view-agent-main-title">User Home Visit Details</h3>
          <h4 className="view-agent-breadcrumb">Home Visit / List / View</h4>
        </div>
      </div>

      {/* Content */}
      {loading ? (
        <div className="agent-content-new">
          <Skeleton active paragraph={{ rows: 10 }} />
        </div>
      ) : (
        <div className="agent-content-new">
          {/* Top Profile Card */}
          <div className="agent-profile-header">
            <div className="agent-profile-main">
              <div className="agent-avatar-placeholder">
                {data?.user?.user_id?.charAt(0) || "U"}
              </div>

              <div className="agent-profile-info">
                <h1 className="agent-name">
                  {data?.user?.user_id || "N/A"}
                </h1>
                <div className="agent-id-badge">
                  OTP: {data?.otp || "—"}
                </div>
              </div>
            </div>

            <div className="agent-status-control">
              <label className="status-label" style={{ marginLeft: "50px" }}>Status</label>
              <div
                className={`status-badge status-${data?.status?.toLowerCase() || "pending"}`}
              >
                {ToFirstCapital(data?.status) || "Pending"}
              </div>
            </div>
          </div>

          {/* Details Grid */}
          <div className="agent-details-grid">
            {/* User Details Card */}
            <div className="agent-card">
              <h3 style={{ borderBottom: "2px solid #f3f4f6", paddingBottom: "14px", margin: "23px", fontSize: "16px" }}>👤 User Details</h3>

              <div className="card-content">
                <div className="info-row">
                  <span className="info-label">Name</span>
                  <span className="info-value" style={{ fontSize: "15px" }}>{data?.user?.name || "—"}</span>
                </div>

                <div className="info-row">
                  <span className="info-label">Email</span>
                  <span className="info-value" style={{ fontSize: "15px" }}>{data?.user?.email || "—"}</span>
                </div>

                <div className="info-row">
                  <span className="info-label">User ID</span>
                  <span className="info-value" style={{ fontSize: "15px" }}>{data?.user?.user_id || "—"}</span>
                </div>

                <div className="info-row">
                  <span className="info-label">Phone</span>
                  <span className="info-value" style={{ fontSize: "15px" }}>
                    {data?.user?.country_code && data?.user?.contact_number
                      ? `${data.user.country_code} ${data.user.contact_number}`
                      : "—"}
                  </span>
                </div>

                {data?.user?.profile_image && (
                  <div className="info-row">
                    <span className="info-label">Profile Image</span>
                    <img
                      src={data.user.profile_image}
                      alt={data.user.name}
                      className="user-profile-image"
                    />
                  </div>
                )}
              </div>
            </div>

            {/* Assigned Agent */}
            <div className="agent-card">
              <h3 style={{ borderBottom: "2px solid #f3f4f6", paddingBottom: "14px", margin: "23px", fontSize: "16px" }}>👨‍💼 Assigned Agent</h3>

              <div className="card-content">
                {data?.agent ? (
                  <>
                    <div className="info-row">
                      <span className="info-label">Name</span>
                      <span className="info-value" style={{ fontSize: "15px" }}>{data.agent.name}</span>
                    </div>

                    <div className="info-row">
                      <span className="info-label">Agent ID</span>
                      <span className="info-value" style={{ fontSize: "15px" }}>{data.agent.staff_id}</span>
                    </div>

                    <div className="info-row">
                      <span className="info-label">Email</span>
                      <span className="info-value" style={{ fontSize: "15px" }}>{data.agent.email}</span>
                    </div>

                    <div className="info-row">
                      <span className="info-label">Phone</span>
                      <span className="info-value" style={{ fontSize: "15px" }}>
                        {data.agent.country_code} {data.agent.contact_number}
                      </span>
                    </div>
                  </>
                ) : (
                  <div className="info-row">
                    <span className="info-value" style={{ fontSize: "15px" }}>No agent assigned</span>
                  </div>
                )}
              </div>
            </div>

            {/* Appointment Info Card */}
            <div className="agent-card">
              <h3 style={{ borderBottom: "2px solid #f3f4f6", paddingBottom: "14px", margin: "23px", fontSize: "16px" }}>📅 Appointment Details</h3>

              <div className="card-content">
                <div className="info-row">
                  <span className="info-label">Date & Time</span>
                  <span className="info-value" style={{ fontSize: "15px" }}>
                    {data?.appointment_date
                      ? new Date(data.appointment_date).toLocaleString("en-US", {
                        dateStyle: "medium",
                        timeStyle: "short",
                      })
                      : "—"}
                  </span>
                </div>

                <div className="info-row">
                  <span className="info-label">Rating</span>
                  <span className="info-value" style={{ fontSize: "15px" }}>
                    {data?.rating > 0 ? (
                      <span className="star-rating">
                        {Array.from(
                          { length: data.rating_by_user_to_agent },
                          (_, i) => (
                            <span key={i}>⭐</span>
                          )
                        )}
                      </span>
                    ) : (
                      "—"
                    )}
                  </span>
                </div>

                <div className="info-row">
                  <span className="info-label">Created At</span>
                  <span className="info-value" style={{ fontSize: "15px" }}>
                    {data?.created_at
                      ? new Date(data.created_at).toLocaleString("en-US", {
                        dateStyle: "medium",
                        timeStyle: "short",
                      })
                      : "—"}
                  </span>
                </div>

                <div className="review-section-wrapper">
                  <div className="review-label-row">
                    <span className="info-label">REVIEW OF USER</span>
                    {data?.review_by_user_to_agent && data.review_by_user_to_agent !== "N/A" && (
                      <button
                        className="review-expand-icon"
                        onClick={() => setIsReviewModalOpen(true)}
                        title="Expand review"
                      >
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                          <path d="M15 3h6v6M9 21H3v-6M21 3l-7 7M3 21l7-7" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                      </button>
                    )}
                  </div>
                  <div className="review-text-container">
                    {data?.review_by_user_to_agent && data.review_by_user_to_agent !== "N/A" ? (
                      <p className="review-text-content">
                        {data.review_by_user_to_agent}
                      </p>
                    ) : (
                      <p className="review-text-content" style={{ color: "#9ca3af" }}>—</p>
                    )}
                  </div>
                </div>
              </div>
            </div>

            {/* Address Card */}
            <div className="agent-card">
              <h3 style={{ borderBottom: "2px solid #f3f4f6", paddingBottom: "14px", margin: "23px", fontSize: "16px" }}>📍 Location Details</h3>
              <div className="card-content">
                <div className="info-row">
                  <span className="info-label">Saved As</span>
                  <span className="info-value" style={{ fontSize: "15px" }}>
                    {ToFirstCapital(data?.address?.save_as) || "—"}
                  </span>
                </div>

                <div className="info-row">
                  <span className="info-label">Address</span>
                  <span className="info-value" style={{ fontSize: "15px" }}>
                    {data?.address?.address || "—"}
                  </span>
                </div>

                <div className="info-row">
                  <span className="info-label">House/Flat</span>
                  <span className="info-value" style={{ fontSize: "15px" }}>
                    {data?.address?.house_flat_floorno || "—"}
                  </span>
                </div>

                <div className="info-row">
                  <span className="info-label">Area</span>
                  <span className="info-value" style={{ fontSize: "15px" }}>
                    {data?.address?.appartment_road_area || "—"}
                  </span>
                </div>

                <div className="info-row">
                  <span className="info-label">Directions</span>
                  <span className="info-value" style={{ fontSize: "15px" }}>
                    {data?.address?.direction_to_reach || "—"}
                  </span>
                </div>

                {latitude && longitude && (
                  <div className="map-container">
                    <iframe
                      title="Location Map"
                      src={`https://www.google.com/maps?q=${latitude},${longitude}&z=15&output=embed`}
                      width="100%"
                      height="280"
                      style={{ border: 0, borderRadius: "16px" }}
                      allowFullScreen=""
                      loading="lazy"
                      referrerPolicy="no-referrer-when-downgrade"
                    />
                  </div>
                )}

                {data?.address?.set_as_default && (
                  <div className="info-row">
                    <span className="info-label">Default Address</span>
                    <span className="info-value" style={{ fontSize: "15px" }}>✓ Yes</span>
                  </div>
                )}
              </div>
            </div>

            {/* ✅ UPDATED: Projects Card + Agent Dropdown */}
            <div className="workspace-panel-wrapper">
              <div className="workspace-panel-top">
                <h3 className="workspace-panel-label">🏗️ Projects</h3>
              </div>

              <div className="workspace-dual-grid">
                <div className="workload-stack">
                  {data?.projects?.length > 0 ? (
                    data.projects.map((proj) => (
                      <div key={proj._id} className="workload-item-block">
                        <div className="workload-field-pair">
                          <label className="workload-field-tag">Project Name</label>
                          <span className="workload-field-content">{proj.project_name}</span>
                        </div>
                        <div className="workload-field-pair">
                          <label className="workload-field-tag">Brand</label>
                          <span className="workload-field-content">{proj.brand_name}</span>
                        </div>
                      </div>
                    ))
                  ) : (
                    <div className="workload-vacant-state">
                      <p className="vacant-message">No projects assigned</p>
                    </div>
                  )}
                </div>

                {/* ✅ ENHANCED Agent Assignment Section */}
                {canAdd && canEdit &&
                  <div className="resource-allocator-box">
                    <div className="resource-allocator-headline">
                      <h4 className="resource-allocator-heading">👤 Assign Agent</h4>
                      {data?.status === "requested" && !data?.agent ? (
                        <span className="assign-agent-badge available">Available</span>
                      ) : data?.agent ? (
                        <span className="assign-agent-badge assigned">Assigned</span>
                      ) : (
                        <span className="assign-agent-badge completed">Completed</span>
                      )}
                    </div>

                    <div className="resource-allocator-body">
                      <div className="dropdown-mount-zone">
                        <Select
                          className="staff-selector-component ant-select-selector-margin"
                          value={data?.agent?._id || data?.agent || undefined}
                          placeholder={
                            data?.agent
                              ? (() => {
                                const assignedAgent = agentsData?.data?.find(
                                  (agent) => agent._id === (data.agent?._id || data.agent)
                                );
                                return assignedAgent
                                  ? <span style={{ marginTop: '-4px' }}>Assigned: {assignedAgent.name}</span>
                                  : "Select agent to assign";
                              })()
                              : "Select agent to assign"
                          }
                          // className="staff-selector-component"
                          loading={agentState.loading || assigningAgent}
                          onChange={handleAgentSelect}
                          allowClear={!data?.agent}
                          optionLabelProp="label"
                          showSearch
                          filterOption={(input, option) =>
                            (option?.children?.props?.children[0]?.props?.children[0] || '')
                              .toLowerCase()
                              .includes(input.toLowerCase())
                          }
                        >
                          {Array.isArray(agentsData?.data) &&
                            agentsData.data.map((agent) => (
                              <Option
                                key={agent._id}
                                value={agent._id}
                                label={`${agent.name} (${agent.staff_id})`} // Used for search/filter
                              >
                                <span className="staff-name-display">{agent.name}</span>
                                <span className="staff-id-display">{agent.staff_id}</span>
                              </Option>
                            ))}
                        </Select>
                      </div>


                      {data?.agent && (
                        <div
                          className="assigned-agent-info"
                          style={{
                            marginTop: 12,
                            padding: "8px 12px",
                            background: "#f0fdf4",
                            borderRadius: "8px",
                            borderLeft: "3px solid #10b981"
                          }}
                        >
                          <span style={{ color: "#059669", fontSize: 14, fontWeight: 500 }}>
                            ✅ Assigned to: {data.agent.name} ({data.agent.staff_id})
                          </span>
                        </div>
                      )}
                    </div>
                  </div>
                }
              </div>
            </div>

            {/* Nearby Agents List */}
            <div className="agent-card" style={{ gridColumn: "1 / -1" }}>
              <div
                className="nearby-agents-header"
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  padding: "20px 23px 0px 0px",
                }}
              >
                <h3 style={{ borderBottom: "2px solid #f3f4f6", paddingBottom: "14px", margin: "21px 21px 21px 29px", fontSize: "16px", width: "100%" }}>👨‍💼 Nearby Agents List</h3>
                <Link to="/agent">
                  <button className="view-all-agents-btn">View All</button>
                </Link>
              </div>
              <div className="card-content">
                {data?.agent_list?.length > 0 ? (
                  <div className="agents-grid">
                    {data.agent_list.map((agent) => (
                      <div key={agent._id} className="agent-detail-card">
                        <div className="agent-detail-header">
                          {agent.profile_image ? (
                            <img
                              src={agent.profile_image}
                              alt={agent.name}
                              className="agent-detail-avatar"
                            />
                          ) : (
                            <div className="agent-detail-avatar-placeholder">
                              {agent.name?.charAt(0) || "A"}
                            </div>
                          )}
                          <div className="agent-detail-info">
                            <h4 className="agent-detail-name">{agent.name}</h4>
                            <span className="agent-detail-id">
                              Agent Id: {agent.staff_id}
                            </span>
                          </div>
                        </div>
                        <div className="agent-detail-contact">
                          <div className="contact-row">
                            <span className="contact-label">📧 Email</span>
                            <span className="contact-value">{agent.email}</span>
                          </div>
                          <div className="contact-row">
                            <span className="contact-label">📱 Phone</span>
                            <span className="contact-value">
                              {agent.country_code} {agent.contact_number}
                            </span>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                ) : (
                  <div className="no-data-message">
                    <div className="no-data-icon">👥</div>
                    <p>No agents assigned to this appointment</p>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}

      <Modal
        title="User Review"
        open={isReviewModalOpen}
        footer={null}
        onCancel={() => setIsReviewModalOpen(false)}
      >
        <p style={{ whiteSpace: "pre-wrap", lineHeight: "1.6" }}>
          {data?.review_by_user_to_agent || "No review available"}
        </p>
      </Modal>
    </div>
  );
};

export default ViewHomeVisit;